import {
  ALL_COSTING_MASTER_SUCCESS,
  ALL_FABRIC_COLOR_MASTER_FAIL,
  ALL_FABRIC_COLOR_MASTER_REQUEST,
  ALL_FABRIC_COLOR_MASTER_SUCCESS,
  ALL_FABRIC_MASTER_FAIL,
  ALL_FABRIC_MASTER_REQUEST,
  ALL_FABRIC_MASTER_SUCCESS,
  ALL_GRADE_MASTER_FAIL,
  ALL_GRADE_MASTER_REQUEST,
  ALL_GRADE_MASTER_SUCCESS,
  ALL_CURRENCY_MASTER_FAIL,
  ALL_CURRENCY_MASTER_REQUEST,
  ALL_CURRENCY_MASTER_SUCCESS,
  ALL_CUT_MASTER_FAIL,
  ALL_CUT_MASTER_REQUEST,
  ALL_CUT_MASTER_SUCCESS,
  ALL_GST_MASTER_FAIL,
  ALL_GST_MASTER_REQUEST,
  ALL_GST_MASTER_SUCCESS,
  ALL_EXPENSE_TYPE_MASTER_FAIL,
  ALL_EXPENSE_TYPE_MASTER_REQUEST,
  ALL_EXPENSE_TYPE_MASTER_SUCCESS,
  ALL_ITEM_CODE_MASTER_FAIL,
  ALL_ITEM_CODE_MASTER_REQUEST,
  ALL_ITEM_CODE_MASTER_SUCCESS,
  ALL_ITEM_NAME_MASTER_FAIL,
  ALL_ITEM_NAME_MASTER_REQUEST,
  ALL_ITEM_NAME_MASTER_SUCCESS,
  ALL_PALLETE_MASTER_FAIL,
  ALL_PALLETE_MASTER_REQUEST,
  ALL_PALLETE_MASTER_SUCCESS,
  ALL_PARTY_MASTER_FAIL,
  ALL_PARTY_MASTER_REQUEST,
  ALL_PARTY_MASTER_SUCCESS,
  ALL_PRODUCT_MASTER_SUCCESS,
  ALL_SUPPLIER_MASTER_SUCCESS,
  ALL_UNIT_MASTER_FAIL,
  ALL_UNIT_MASTER_REQUEST,
  ALL_UNIT_MASTER_SUCCESS,
  FETCH_ALL_ITEMS_CATEGORY_FAIL,
  FETCH_ALL_ITEMS_CATEGORY_REQUEST,
  FETCH_ALL_ITEMS_CATEGORY_SUCCESS,
  FETCH_ALL_ITEMS_SUBCATEGORY_FAIL,
  FETCH_ALL_ITEMS_SUBCATEGORY_REQUEST,
  FETCH_ALL_ITEMS_SUBCATEGORY_SUCCESS,
  FETCH_ALL_SUPPLIER_MASTER_BRANCHES__FAIL,
  FETCH_ALL_SUPPLIER_MASTER_BRANCHES_LIST_REQUEST,
  FETCH_ALL_SUPPLIER_MASTER_BRANCHES_LIST_SUCCESS,
  FETCH_ALL_SUPPLIER_MASTER_FAIL,
  FETCH_ALL_SUPPLIER_MASTER_LIST_REQUEST,
  FETCH_ALL_SUPPLIER_MASTER_LIST_SUCCESS,
  LOAD_COSTING_MASTER_FAIL,
  LOAD_COSTING_MASTER_REQUEST,
  LOAD_PRODUCT_MASTER_FAIL,
  LOAD_PRODUCT_MASTER_REQUEST,
  LOAD_SUPPLIER_MASTER_FAIL,
  LOAD_SUPPLIER_MASTER_REQUEST,
  FETCH_ALL_SERIES_REQUEST,
  FETCH_ALL_SERIES_SUCCESS,
  FETCH_ALL_SERIES_FAIL,
  FETCH_ALL_DEPARTMENT_REQUEST,
  FETCH_ALL_DEPARTMENT_SUCCESS,
  FETCH_ALL_DEPARTMENT_FAIL,
  FETCH_ALL_MACHINE_REQUEST,
  FETCH_ALL_MACHINE_SUCCESS,
  FETCH_ALL_MACHINE_FAIL,
  FETCH_ALL_CHARACTER_REQUEST,
  FETCH_ALL_CHARACTER_SUCCESS,
  FETCH_ALL_CHARACTER_FAIL,
  FETCH_ALL_PATTERN_REQUEST,
  FETCH_ALL_PATTERN_SUCCESS,
  FETCH_ALL_PATTERN_FAIL,
  FETCH_ALL_PROCESS_REQUEST,
  FETCH_ALL_PROCESS_SUCCESS,
  FETCH_ALL_PROCESS_FAIL,
  FETCH_ALL_COLOUR_REQUEST,
  FETCH_ALL_COLOUR_SUCCESS,
  FETCH_ALL_COLOUR_FAIL,
  FETCH_ALL_TRANSPORTER_REQUEST,
  FETCH_ALL_TRANSPORTER_SUCCESS,
  FETCH_ALL_TRANSPORTER_FAIL,
  FETCH_ALL_VEHICLE_REQUEST,
  FETCH_ALL_VEHICLE_SUCCESS,
  FETCH_ALL_VEHICLE_FAIL,
  FETCH_ALL_DISPATCH_ADDRESS_REQUEST,
  FETCH_ALL_DISPATCH_ADDRESS_SUCCESS,
  FETCH_ALL_DISPATCH_ADDRESS_FAIL,
  FETCH_ALL_PHOTO_REQUEST,
  FETCH_ALL_PHOTO_SUCCESS,
  FETCH_ALL_PHOTO_FAIL,
  FETCH_ALL_CUSTOMER_REQUEST,
  FETCH_ALL_CUSTOMER_SUCCESS,
  FETCH_ALL_CUSTOMER_FAIL,
  FETCH_ALL_CUSTOMER_CLIENT_REQUEST,
  FETCH_ALL_CUSTOMER_CLIENT_SUCCESS,
  FETCH_ALL_CUSTOMER_CLIENT_FAIL,
  FETCH_ALL_POLISH_REQUEST,
  FETCH_ALL_POLISH_SUCCESS,
  FETCH_ALL_POLISH_FAIL,
  FETCH_ALL_LENGTH_REQUEST,
  FETCH_ALL_LENGTH_SUCCESS,
  FETCH_ALL_LENGTH_FAIL,
  FETCH_ALL_WIDTH_REQUEST,
  FETCH_ALL_WIDTH_SUCCESS,
  FETCH_ALL_WIDTH_FAIL,
  FETCH_ALL_THICKNESS_REQUEST,
  FETCH_ALL_THICKNESS_SUCCESS,
  FETCH_ALL_THICKNESS_FAIL,
  FETCH_ALL_PHOTO_ALBUM_REQUEST,
  FETCH_ALL_PHOTO_ALBUM_SUCCESS,
  FETCH_ALL_PHOTO_ALBUM_FAIL,
} from "app/utils/constants/masterConstants";

const INIT_STATE = {
  loading: false,
  error: null,
  supplierMaster: [],
  supplierMasterBranches: [],
  itemCategoryMaster: [],
  itemSubCategoryMaster: [],
  gradeMaster: [],
  currencyMaster: [],
  cutMaster: [],
  gstMaster: [],
  expenseTypeMaster: [],
  partyMaster: [],
  unitMaster: [],
  palleteMaster: [],
  itemNameMaster: [],
  itemCodeMaster: [],
  supplierList: [],
  seriesList: [],
  departmentList: [],
  machineList: [],
  photoList: [],
  photoAlbumList: [],
  polishList: [],
  lengthMasterList: [],
  widthMasterList: [],
  thicknessMasterList: [],
  TotalPage: null,
  totalCount: 0,
  loadingMore: false,
};

export const masterReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOAD_SUPPLIER_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_SUPPLIER_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        supplierMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case LOAD_SUPPLIER_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        supplierMaster: [],
        error: action.payload,
      };

    case LOAD_COSTING_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_COSTING_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        costingMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case LOAD_COSTING_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        costingMaster: [],
        error: action.payload,
      };

    case LOAD_PRODUCT_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_PRODUCT_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        productMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case LOAD_PRODUCT_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        productMaster: [],
        error: action.payload,
      };

    //suplier_branches
    case FETCH_ALL_SUPPLIER_MASTER_BRANCHES_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_SUPPLIER_MASTER_BRANCHES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        supplierMasterBranches: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case FETCH_ALL_SUPPLIER_MASTER_BRANCHES__FAIL:
      return {
        ...state,
        supplierMasterBranches: [],
        error: action.payload,
      };

    // item category master
    case FETCH_ALL_ITEMS_CATEGORY_REQUEST:
      return { ...state, loading: true };
    case FETCH_ALL_ITEMS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        itemCategoryMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case FETCH_ALL_ITEMS_CATEGORY_FAIL:
      return { ...state, itemCategoryMaster: [], error: action.payload };

    // item subcategory master
    case FETCH_ALL_ITEMS_SUBCATEGORY_REQUEST:
      return { ...state, loading: true };
    case FETCH_ALL_ITEMS_SUBCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        itemSubCategoryMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case FETCH_ALL_ITEMS_SUBCATEGORY_FAIL:
      return { ...state, itemSubCategoryMaster: [], error: action.payload };

    //grade master
    case ALL_GRADE_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_GRADE_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        gradeMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_GRADE_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        gradeMaster: [],
        error: action.payload,
      };

    //currency master
    case ALL_CURRENCY_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_CURRENCY_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        currencyMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_CURRENCY_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        currencyMaster: [],
        error: action.payload,
      };

    //cut master
    case ALL_CUT_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_CUT_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        cutMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_CUT_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        cutMaster: [],
        error: action.payload,
      };

    //gst master
    case ALL_GST_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_GST_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        gstMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_GST_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        gstMaster: [],
        error: action.payload,
      };

    //expense type master
    case ALL_EXPENSE_TYPE_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_EXPENSE_TYPE_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        expenseTypeMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_EXPENSE_TYPE_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        expenseTypeMaster: [],
        error: action.payload,
      };

    //party master
    case ALL_PARTY_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_PARTY_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        partyMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_PARTY_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        partyMaster: [],
        error: action.payload,
      };

    //unit master
    case ALL_UNIT_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_UNIT_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        unitMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_UNIT_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        unitMaster: [],
        error: action.payload,
      };

    //pallete master
    case ALL_PALLETE_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_PALLETE_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        palleteMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_PALLETE_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        palleteMaster: [],
        error: action.payload,
      };

    //fabricColor master
    case ALL_FABRIC_COLOR_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_FABRIC_COLOR_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        fabricColorMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_FABRIC_COLOR_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        fabricColorMaster: [],
        error: action.payload,
      };

    //item name master
    case ALL_ITEM_NAME_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_ITEM_NAME_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        itemNameMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_ITEM_NAME_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        itemNameMaster: [],
        error: action.payload,
      };

    //item Type  master
    case ALL_ITEM_CODE_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_ITEM_CODE_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        itemCodeMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_ITEM_CODE_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        itemCodeMaster: [],
        error: action.payload,
      };

    //fabric master
    case ALL_FABRIC_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_FABRIC_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        fabricMaster: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_FABRIC_MASTER_FAIL:
      return {
        ...state,
        loading: false,
        fabricMaster: [],
        error: action.payload,
      };

    //new supplier-master
    case FETCH_ALL_SUPPLIER_MASTER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_SUPPLIER_MASTER_LIST_SUCCESS:
      return { ...state, loading: false, supplierList: action.payload.data, totalPage: action.payload.totalPage };

    case FETCH_ALL_SUPPLIER_MASTER_FAIL:
      return { ...state, loading: false, supplierList: [], error: action.payload };

    //series - master
    case FETCH_ALL_SERIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_SERIES_SUCCESS:
      return { ...state, loading: false, seriesList: action.payload.data, TotalPage: action.payload.totalPage };

    case FETCH_ALL_SERIES_FAIL:
      return { ...state, loading: false, seriesList: [], error: action.payload };

    //department - master
    case FETCH_ALL_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_DEPARTMENT_SUCCESS:
      return { ...state, loading: false, departmentList: action.payload.data, totalPage: action.payload.totalPage };

    case FETCH_ALL_DEPARTMENT_FAIL:
      return { ...state, loading: false, departmentList: [], error: action.payload };

    case FETCH_ALL_MACHINE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_MACHINE_SUCCESS:
      return { ...state, loading: false, machineList: action.payload.data, TotalPage: action.payload.totalPage };

    case FETCH_ALL_MACHINE_FAIL:
      return { ...state, loading: false, machineList: [], error: action.payload };

    case FETCH_ALL_CHARACTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_CHARACTER_SUCCESS:
      return { ...state, loading: false, characterList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_CHARACTER_FAIL:
      return { ...state, loading: false, characterList: [], error: action.payload };

    case FETCH_ALL_PATTERN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_PATTERN_SUCCESS:
      return { ...state, loading: false, patternList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_PATTERN_FAIL:
      return { ...state, loading: false, patternList: [], error: action.payload };

    case FETCH_ALL_PROCESS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_PROCESS_SUCCESS:
      return { ...state, loading: false, processList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_PROCESS_FAIL:
      return { ...state, loading: false, processList: [], error: action.payload };

    case FETCH_ALL_COLOUR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_COLOUR_SUCCESS:
      return { ...state, loading: false, colourList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_COLOUR_FAIL:
      return { ...state, loading: false, colourList: [], error: action.payload };

    case FETCH_ALL_TRANSPORTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_TRANSPORTER_SUCCESS:
      return { ...state, loading: false, transporterList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_TRANSPORTER_FAIL:
      return { ...state, loading: false, transporterList: [], error: action.payload };

    case FETCH_ALL_VEHICLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_VEHICLE_SUCCESS:
      return { ...state, loading: false, vehicleList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_VEHICLE_FAIL:
      return { ...state, loading: false, vehicleList: [], error: action.payload };

    case FETCH_ALL_DISPATCH_ADDRESS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_DISPATCH_ADDRESS_SUCCESS:
      return { ...state, loading: false, dispatchAddressList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_DISPATCH_ADDRESS_FAIL:
      return { ...state, loading: false, dispatchAddressList: [], error: action.payload };

    //photo reducer
    case FETCH_ALL_PHOTO_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_ALL_PHOTO_SUCCESS:
      return { ...state, loading: false, photoList: action.payload.data, totalPage: action.payload.totalPage };

    case FETCH_ALL_PHOTO_FAIL:
      return { ...state, loading: false, photoList: [], error: action.payload };

    //photo album reducer
    case FETCH_ALL_PHOTO_ALBUM_REQUEST:
      return {
        ...state,
        loading: !action.payload?.append,
        loadingMore: !!action.payload?.append,
        error: null,
      };

    case FETCH_ALL_PHOTO_ALBUM_SUCCESS: {
      const incoming = action.payload?.data || [];
      let nextList = incoming;

      if (action.payload?.append) {
        const existingIds = new Set(
          (state.photoAlbumList || []).map((item) => String(item?._id))
        );
        const uniqueIncoming = incoming.filter(
          (item) => item?._id != null && !existingIds.has(String(item._id))
        );
        nextList = [...(state.photoAlbumList || []), ...uniqueIncoming];
      }

      return {
        ...state,
        loading: false,
        loadingMore: false,
        photoAlbumList: nextList,
        totalPage: action.payload.totalPage,
        totalCount: action.payload.totalCount ?? 0,
      };
    }

    case FETCH_ALL_PHOTO_ALBUM_FAIL:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        // Keep already-loaded rows when a "load more" request fails
        photoAlbumList: action.payload?.append ? state.photoAlbumList : [],
        error: action.payload?.error ?? action.payload,
      };

    //polish reducer
    case FETCH_ALL_POLISH_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_ALL_POLISH_SUCCESS:
      return { ...state, loading: false, polishList: action.payload.data, totalPage: action.payload.totalPage };

    case FETCH_ALL_POLISH_FAIL:
      return { ...state, loading: false, polishList: [], error: action.payload };

    //==============
    case FETCH_ALL_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_CUSTOMER_SUCCESS:
      return { ...state, loading: false, customerList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_CUSTOMER_FAIL:
      return { ...state, loading: false, customerList: [], error: action.payload };

    case FETCH_ALL_CUSTOMER_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_CUSTOMER_CLIENT_SUCCESS:
      return { ...state, loading: false, customerClientList: action.payload.data, totalPage: action.payload.totalPage };
    case FETCH_ALL_CUSTOMER_CLIENT_FAIL:
      return { ...state, loading: false, customerClientList: [], error: action.payload };

    //Length reducer
    case FETCH_ALL_LENGTH_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_ALL_LENGTH_SUCCESS:
      return { ...state, loading: false, lengthMasterList: action.payload.data, totalPage: action.payload.totalPage };

    case FETCH_ALL_LENGTH_FAIL:
      return { ...state, loading: false, lengthMasterList: [], error: action.payload };

    //width reducer
    case FETCH_ALL_WIDTH_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_ALL_WIDTH_SUCCESS:
      return { ...state, loading: false, widthMasterList: action.payload.data, totalPage: action.payload.totalPage };

    case FETCH_ALL_WIDTH_FAIL:
      return { ...state, loading: false, widthMasterList: [], error: action.payload };

    //thickness reducer
    case FETCH_ALL_THICKNESS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_ALL_THICKNESS_SUCCESS:
      return { ...state, loading: false, thicknessMasterList: action.payload.data, totalPage: action.payload.totalPage };

    case FETCH_ALL_THICKNESS_FAIL:
      return { ...state, loading: false, thicknessMasterList: [], error: action.payload };

    default:
      return state;
  }
};
